import React from "react"

import PropTypes from "prop-types"

import * as styles from "./form.module.scss"
import Button from "../../atoms/button"
import CopyContainer from "../../atoms/copy-container"
import Icon from "../../atoms/icon"
import FormState from "../form-state"

const Form = ({
  children,
  handleSubmit,
  errorMessage,
  submitText,
  formState,
  className,
  buttonVariant,
  trackSubscribe,
}) => (
  <form className={`${styles.form} ${className}`} onSubmit={handleSubmit}>
    <FormState condition={formState === "error"} error>
      <CopyContainer
        content={typeof errorMessage === "object" ? errorMessage : null}
      >
        {typeof errorMessage === "string" ? errorMessage : null}
      </CopyContainer>
    </FormState>
    <div className={styles.content}>{children}</div>
    {buttonVariant === "none" ? (
      ""
    ) : (
      <Button
        variant={buttonVariant}
        className={`${trackSubscribe ? "subscribe_submit" : ""} ${styles.submit}`}
        submit
        disabled={formState === "pending"}
      >
        {formState === "pending" ? <Icon icon="autorenew" spin /> : submitText}
      </Button>
    )}
  </form>
)

export default Form

Form.propTypes = {
  children: PropTypes.node.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  submitText: PropTypes.string,
  formState: PropTypes.string,
  className: PropTypes.string,
  buttonVariant: PropTypes.string,
  trackSubscribe: PropTypes.bool,
}

Form.defaultProps = {
  errorMessage: "Error, please try again.",
  submitText: "Submit",
  formState: "",
  className: "",
  buttonVariant: "primary",
  trackSubscribe: false,
}
